exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled-button[data-v-163311c1]{cursor:not-allowed}", ""]);

// exports
